/**
 * @module builder
 */
import type { OptionsDocument, QuoteDocument } from 'paintscout'
import type { UpdateableGroup } from '../index'
import type { QuoteItemSection } from '../../index'
import { getGroup } from '../get-group'
import { getGroupDetails } from '../get-group-details'
import { getGroupSubstrateChildren } from '../get-group-substrate-children'
import { updateGroup } from '../update-group'
import { uuid } from '../../../util'

export function createGroup(args: {
  quote: QuoteDocument
  clientOptions: OptionsDocument
  keys: string[]
  key?: string
  section?: QuoteItemSection
}): UpdateableGroup {
  const { quote, keys, key = uuid(), clientOptions, section: givenSection } = args

  const generatedKey = key

  const substrateChildren = getGroupSubstrateChildren({ quote, options: clientOptions, section: givenSection, keys })

  const {
    label,
    description: defaultDescription,
    price,
    files,
    quoteType,
    view,
    section
  } = getGroupDetails({
    options: clientOptions,
    section: givenSection,
    groupKey: generatedKey,
    quote,
    keys
  })

  const group: UpdateableGroup = {
    key: generatedKey,
    type: 'group',
    label,
    description: { useCustom: false, custom: '', default: defaultDescription },
    price: { useCustom: false, custom: 0, default: price },
    section,
    children: keys,
    substrateChildren,
    files,
    view,
    quoteType
  }

  const updatedQuote = updateGroup({
    quote,
    options: clientOptions,
    group,
    calculate: true,
    section
  })

  const updatedGroup = getGroup({ quote: updatedQuote, key: generatedKey })

  return updatedGroup
}
